module.exports = __webpack_public_path__ + "static/media/Home.60cd1c18.md";